/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IUserController,
  IUserControllerInterface,
} from "../IUserController";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "isStoryPassed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "openedNgLevel",
        type: "uint8",
      },
    ],
    name: "registerFameHallHero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "registerPassedDungeon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isWinner",
        type: "bool",
      },
    ],
    name: "registerPvP",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "setStoryPassed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "useGamePointsToSkipStore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IUserController__factory {
  static readonly abi = _abi;
  static createInterface(): IUserControllerInterface {
    return new Interface(_abi) as IUserControllerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IUserController {
    return new Contract(address, _abi, runner) as unknown as IUserController;
  }
}
